import React, { useState } from 'react';

import { PressableBox, Text } from '@opendoor/bricks-next';

export const SkipLink: React.FC = () => {
  const [focused, setFocused] = useState(false);

  return (
    <PressableBox
      analyticsName="cosmos-landing-page-v2-skip-to-main-content"
      aria-label="Skip navigation menu and view main content"
      role="button"
      onPress={() => {
        if (typeof window === 'undefined') {
          return;
        }
        const mainElem = document.querySelector('main');
        mainElem?.focus();
      }}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      backgroundColor="$backgroundPrimary"
      justifyContent="center"
      width="100%"
      py="$3"
      px="$4"
      zIndex={1}
      $platform-web={{
        position: 'fixed',
        top: 0,
        left: 0,
        transform: focused ? 'translateY(0)' : 'translateY(-100%)',
        transition: 'transform 0.2s ease-in-out',
      }}
    >
      <Text tag="span" color="$contentAccentBrand" typography="$labelMedium">
        Skip to main content
      </Text>
    </PressableBox>
  );
};
